var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper container container-margin"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 content-center-aligned"},[_c('img',{staticClass:"logo-text",attrs:{"src":_vm.textLogo}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }